<template>
  <div class="connet">
    <div class="main orderMain">
      <div class="topSearch">
        <div class="CM_heand flexBox" style="justify-content: flex-start">
          <div class="statusInput">
            <span>处方种类：</span>
            <el-select v-model="prescrKind" placeholder="请选择">
              <el-option
                  v-for="item in prescrKindOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="statusInput">
            <span>订单状态：</span
            >
            <el-select v-model="status" placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="searchTime">
            <el-date-picker
                v-model="value1"
                type="datetimerange"
                range-separator="——"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="chooseTime"
                :clearable="false"
            >
            </el-date-picker>
          </div>
          <div class="searchInput">
            <el-input
                placeholder="搜索用户姓名/身份证号/手机号"
                v-model="keyword"
                prefix-icon="el-icon-search"
                @keyup.enter.native="searchTable"
            ></el-input>
          </div>
          <el-button @click="searchTable" type="success">查询</el-button>
          <el-button @click="queryPsn" type="success" v-loading="loading2">挂号</el-button>
        </div>
      </div>
      <div class="orderTable">
        <el-table
            :data="tableData"
            :style="{ width: flexWidth + 'px' }"
            style="min-height: 94%"
            v-loading="loading"
            :cell-class-name="tableRowClassName"
        >
          <!--          <el-table-column prop="type" label="类型" width="85px">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span-->
          <!--                  v-if="scope.row.type == 1"-->
          <!--                  class="statusStyle2"-->
          <!--              >专家咨询</span-->
          <!--              >-->
          <!--              <span-->
          <!--                  v-if="scope.row.type == 2"-->
          <!--                  class="statusStyle4"-->
          <!--              >复诊开方</span-->
          <!--              >-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="支付类型" width="110px">-->
          <!--            <template slot-scope="scope">-->
          <!--            <span v-if="scope.row.payType == 1" class="statusStyle2">-->
          <!--              自费处方-->
          <!--            </span>-->
          <!--              <span v-else class="statusStyle4">-->
          <!--              医保处方-->
          <!--            </span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column prop="pharmacyName" label="药房名称" width="280px">-->
          <!--          </el-table-column>-->
          <el-table-column label="处方种类"  width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.prescrKind == 1" class="statusStyle4">西药</span>
              <span v-else-if="scope.row.prescrKind == 2" class="statusStyle2">中药</span>
              <span v-else>未知</span>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="姓名">
          </el-table-column>
          <el-table-column prop="idNo" label="身份证号"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="createTime" label="创建时间">
          </el-table-column>
          
          <el-table-column prop="status" label="订单状态" width="80">
            <template slot-scope="scope">
              <span
                  v-if="scope.row.status == 1"
                  class="status"
                  style="color: #ff7500; background: #ff8d3c24"
              >
                待支付</span
              >
              <span
                  v-if="scope.row.status == 2"
                  class="status"
                  style="color: #bbca41; background: #ebfd5140"
              >待接诊</span
              >
              <span
                  v-else-if="scope.row.status == 3"
                  class="status"
                  style="color: #1dc11d; background: #e8f9e8"
              >
                已完成</span
              >
              <span
                  v-else-if="scope.row.status == 4"
                  class="status"
                  style="color: #ff2121; background: #ff21213b"
              >
                已取消</span
              >
              <span
                  v-else-if="scope.row.status == 5"
                  class="status"
                  style="color: #758a99; background: #c3c3c333"
              >
                退费中</span
              >
              <span
                  v-else-if="scope.row.status == 6"
                  class="status"
                  style="color: #685757; background: #e9e7ef"
              >
                已退费</span
              >
              <span
                  v-else-if="scope.row.status == 7"
                  class="status"
                  style="color: #685757; background: #e9e7ef"
              >
                接诊中</span
              >
              <span
                  v-else-if="scope.row.status == 10"
                  class="status"
                  style="color: #685757; background: #e9e7ef"
              >
                已关闭</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90px">
            <template slot-scope="scope">
              <el-button
                  type="text"
                  @click="goDetails(scope.row)"
                  style="padding: 0px"
              >详情
              </el-button
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <div style="padding-top: 2rem">
              <img
                  src="../../../img/nullStatus.png"
                  alt=""
                  style="width: 240px; height: 180px"
              />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <el-pagination
            :page-size="10"
            :pager-count="5"
            layout="total,prev, pager, next"
            :total="TableTotal"
            :current-page.sync="currentPage"
            @current-change="currentChangeHandle"
            class="paginationBox"
            align="center"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
        title="用户信息"
        :visible.sync="dialogVisible"
        width="80%">
      <table style="width: 100%" class="dataForm accountDataForm">
        <tr>
          <td>
            <span><span class="mustIcon">*</span>姓名：</span>
            <el-input class="dataInput" v-model="userInfo.name" disabled></el-input>
          </td>
          <td>
            <span><span class="mustIcon">*</span>身份证：</span>
            <el-input class="dataInput" v-model="userInfo.idNo" disabled></el-input>
          </td>
          <td>
            <span><span class="mustIcon">*</span>手机号：</span>
            <el-input class="dataInput" v-model="userInfo.phone" :disabled="phoneFlag"></el-input>
          </td>
          <td>
            <span><span class="mustIcon">*</span>地址：</span>
            <el-input class="dataInput" v-model="userInfo.empName"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <span><span class="mustIcon">*</span>诊断：</span>
            <el-select
                v-model="illName"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="请输入诊断名称"
                :remote-method="remoteMethod"
                class="illNameSelector"
                v-load-more="loadMoreIllName"
                @change="bindChange"
                @visible-change="clearIllNameOptions"
                ref="clearValue"
                style="width: 460px"
            >
              <el-option
                  v-for="item in illNameOptions"
                  :key="item.diagnosisName"
                  :label="item.diagnosisName"
                  :value="item.diagnosisName"
              >
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <span><span class="mustIcon">*</span>病情描述：</span>
            <el-input class="dataInput" v-model="illDesc" style="width: 460px"></el-input>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <p style="margin-bottom: 12px">
                <span class="label_icon">*</span><span class="label">请选择患病时长</span>
              </p>
              <el-radio-group v-model="illTime">
                <el-radio
                    label="一个月内"
                    :class="{ nullValue: fromProving.illTimeFlag }"
                ></el-radio>
                <el-radio
                    label="半年内"
                    :class="{ nullValue: fromProving.illTimeFlag }"
                ></el-radio>
                <el-radio
                    label="一年内"
                    :class="{ nullValue: fromProving.illTimeFlag }"
                ></el-radio>
                <el-radio
                    label="一年以上"
                    :class="{ nullValue: fromProving.illTimeFlag }"
                ></el-radio>
              </el-radio-group>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <p style="margin-bottom: 12px">
                <span class="label_icon">*</span><span class="label">请选择有无疾病史</span>
              </p>
              <el-radio-group v-model="diseaseFlag">
                <el-radio label="无">无</el-radio>
                <el-radio label="有">有</el-radio>
              </el-radio-group>
              <div
                  class="father_box"
                  @click="onclick"
                  v-if="diseaseFlag == '有'"
                  :class="{ nullValue: fromProving.disease }"
                  style="margin-top: 12px"
              >
                <!-- 生成的标签 -->
                <div v-for="(item, index) in TagsAll" :key="index" class="spanbox">
                  <span class="tagspan">{{ item }}</span>
                  <i class="span_close" @click="removeTag(index, item)"></i>
                </div>
                <!-- 输入框 -->
                <input
                    placeholder="输入后按<回车>添加"
                    v-model="currentval"
                    @keyup.enter="addTags"
                    @blur="addTags"
                    @keyup.delete="deleteTags"
                    :style="inputStyle"
                    class="inputTag"
                    ref="inputTag"
                    type="text"
                />
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <p style="margin-bottom: 12px">
                <span class="label_icon">*</span><span class="label">您是否有药物过敏史</span>
              </p>
              <el-radio-group v-model="allergyFlag" @change="changeDisabledFlag">
                <el-radio
                    label="否"
                    :class="{ nullValue: fromProving.allergy_Flag }"
                ></el-radio>
                <el-radio
                    label="是"
                    :class="{ nullValue: fromProving.allergy_Flag }"
                ></el-radio>
              </el-radio-group>
              <el-input
                  placeholder="请输入对何种药物过敏"
                  :disabled="disabledFlag"
                  v-model="allergyName"
                  @blur="allergyNameProving"
                  v-if="allergyFlag == '是'"
                  :class="{ nullValue: fromProving.allergy_Name }"
                  maxlength="30"
                  style="margin-top: 12px"
              ></el-input>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <p style="margin-bottom: 12px">
            <span class="label_icon">*</span
            ><span class="label">请选择肝功能状态</span>
              </p>
              <el-radio-group v-model="liverFunction">
                <el-radio
                    label="NORMAL"
                    :class="{ nullValue: fromProving.illTimeFlag }"
                >正常
                </el-radio
                >
                <el-radio
                    label="ABNORMAL"
                    :class="{ nullValue: fromProving.illTimeFlag }"
                >异常
                </el-radio
                >
                <el-radio
                    label="UNKOWN"
                    :class="{ nullValue: fromProving.illTimeFlag }"
                >未知
                </el-radio
                >
              </el-radio-group>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <p style="margin-bottom: 12px">
            <span class="label_icon">*</span
            ><span class="label">请选择肾功能状态</span>
              </p>
              <el-radio-group v-model="renalFunction">
                <el-radio
                    label="NORMAL"
                    :class="{ nullValue: fromProving.illTimeFlag }"
                >正常
                </el-radio
                >
                <el-radio
                    label="ABNORMAL"
                    :class="{ nullValue: fromProving.illTimeFlag }"
                >异常
                </el-radio
                >
                <el-radio
                    label="UNKOWN"
                    :class="{ nullValue: fromProving.illTimeFlag }"
                >未知
                </el-radio
                >
              </el-radio-group>
            </div>
          </td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="dialogVisible = false" plain>取 消</el-button>
        <el-button type="primary" @click="register" class="registerBtn" v-loading="loading">挂 号</el-button>
      </span>
    </el-dialog>
    <el-dialog
        :visible.sync="outFlag"
        width="30%"
        :show-close="false"
        class="tipsMsgBox"
        :modal="false"
    >
      <span style="font-size: 20px; font-weight: 800">
        {{ errorMsg }}
      </span>
    </el-dialog>
    <el-dialog
        :visible.sync="tipsFlag"
        width="30%"
        :show-close="false"
        :close-on-click-modal="false"
        class="tipsMsgBox"
        :modal="false"
    >
      <span style="font-size: 20px; font-weight: 800">{{ tipsMsg }}</span>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/config/axios'
import {dictDataList, order, orderSelfList} from "@/api/index";

export default {
  data() {
    return {
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "待支付",
        },
        {
          value: "2",
          label: "待接诊",
        },
        {
          value: "7",
          label: "接诊中",
        },
        {
          value: "3",
          label: "已完成",
        },
        {
          value: "4",
          label: "已取消",
        },
        {
          value: "5",
          label: "退费中",
        },
        {
          value: "6",
          label: "已退费",
        },
        {
          value: "10",
          label: "已关闭",
        },
      ],
      prescrKindOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "西药处方",
        },
        {
          value: "2",
          label: "中药处方",
        },
      ],
      prescrKind: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      status: "",
      value1: [],
      flexWidth: 0,
      tableData: [],
      screenWidth: 0,
      keyword: "",
      startTime: "",
      endTime: "",
      TableTotal: 0,
      loading: false,
      loading2: false,
      outFlag: false,
      errorMsg: "",
      currentPage: 1,
      hasMore: false,
      firstLoad: true,
      buttonLoading: false,
      dialogVisible: false,
      phoneFlag: false,
      userInfo: {},
      illName: [],
      illNameKeyWord: "",
      illNameOptions: [],
      illNameOptionsCp: 1,
      illNameCount: 1,
      illDesc: "",
      illTime: "一个月内",
      diseaseFlag: "无",
      liverFunction: "NORMAL",
      renalFunction: "NORMAL",
      allergyFlag: "否",
      allergyName: "",
      otherSickFlag: "0",
      currentval: "",
      TagsAll: [],
      disabledFlag: true,
      fromProving: {
        imgFlag: false,
        illNameFlag: false,
        illTimeFlag: false,
        allergy_Flag: false,
        allergy_Name: false,
        illDescFlag: false,
        otherSick_Flag: false,
        userNameFlag: false,
        idNoFlag: false,
        phoneFlag: false,
        ssqFlag: false,
        areaFlag: false,
        addressFlag: false,
        disease: false,
      },
      order: {},
      tipsFlag: false,
      tipsMsg: "",
    };
  },
  watch: {
    screenWidth: function (n, o) {
      this.flexWidth = n - 305;
      if (this.flexWidth < 1548) {
        this.flexWidth = 1548;
      }
    },
  },
  mounted() {
    let that = this;
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
    if (this.$route.meta.keepData) {
      let keepData = JSON.parse(localStorage.getItem("keepData"));
      that.status = keepData.status;
      that.value1 = keepData.value1;
      that.keyword = keepData.keyword;
      that.tableData = keepData.tableData;
      that.TableTotal = keepData.TableTotal;
      that.currentPage = keepData.currentPage;
    } else {
      this.OrderList();
    }
  },
  created: function () {
    var now = new Date();
    var year = now.getFullYear();
    var month = this.twoDigits(now.getMonth() + 1);
    var day = this.twoDigits(now.getDate());
    this.startTime = `${year}-${month}-${day} 00:00:00`;
    this.endTime = `${year}-${month}-${day} 23:59:59`;
    this.value1[0] = this.startTime;
    this.value1[1] = this.endTime;
  },
  destroyed() {
    window.onresize = null;
  },
  methods: {
    hand() {
      //脱敏
      this.tableData.forEach((item) => {
        if (item.userName.length == 3) {
          item.userName = item.userName.replace(/^(.).+(.)$/, "$1**");
        } else if (item.userName.length == 2) {
          item.userName = item.userName.replace(/^(.).+$/, "$1*");
        } else if (item.userName.length == 4) {
          item.userName = item.userName.replace(/^(.{2}).+(.)/, "$1**");
        }
      });
    },
    OrderList() {
      this.loading = true;
      let postData = {
        cp: 1,
        lz: 10,
        status: this.status,
        prescrKind: this.prescrKind,
        startTime: this.startTime,
        endTime: this.endTime,
        keyword: this.keyword,
      };
      orderSelfList(postData).then((data) => {
        if (data.code == 0) {
          this.tableData = data.data.data;
          let now = new Date();
          let year = now.getFullYear();
          let month = now.getMonth() + 1;
          let date = now.getDate();
          this.tableData.forEach((item) => {
            item.refundFlag = false;
            if (item.payTime) {
              let payYear = item.payTime.substring(0, 4);
              let payMonth = item.payTime.substring(5, 7);
              let payDate = item.payTime.substring(8, 10);
              if (parseInt(payYear) === year && parseInt(payMonth) === month && parseInt(payDate) === date) {
                item.refundFlag = true;
              }
            }
          });
          this.TableTotal = data.data.count;
          this.loading = false;
        } else {
          this.loading = false;
          this.outFlag = true;
          this.errorMsg = data.msg;
          setTimeout(() => {
            this.outFlag = false;
          }, 2000);
        }
      });
    },
    goDetails(row) {
      let keepData = {
        status: this.status,
        value1: this.value1,
        keyword: this.keyword,
        tableData: this.tableData,
        TableTotal: this.TableTotal,
        currentPage: this.currentPage
      }
      localStorage.setItem("detailsId", row.id);
      localStorage.setItem("keepData", JSON.stringify(keepData));
      this.$router.push({
        path: "/orderDetails",
      });
    },
    twoDigits(val) {
      if (val < 10) return "0" + val;
      return val;
    },
    chooseTime() {
      if (this.value1) {
        this.startTime = this.value1[0];
        this.startTime =
            this.startTime.getFullYear() +
            "-" +
            this.twoDigits(this.startTime.getMonth() + 1) +
            "-" +
            this.twoDigits(this.startTime.getDate()) +
            " " +
            this.twoDigits(this.startTime.getHours()) +
            ":" +
            this.twoDigits(this.startTime.getMinutes()) +
            ":" +
            this.twoDigits(this.startTime.getSeconds());
        this.endTime = this.value1[1];
        this.endTime =
            this.endTime.getFullYear() +
            "-" +
            this.twoDigits(this.endTime.getMonth() + 1) +
            "-" +
            this.twoDigits(this.endTime.getDate()) +
            " " +
            this.twoDigits(this.endTime.getHours()) +
            ":" +
            this.twoDigits(this.endTime.getMinutes()) +
            ":" +
            this.twoDigits(this.endTime.getSeconds());
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
    searchTable() {
      let postData = {
        cp: 1,
        lz: 10,
        status: this.status,
        prescrKind: this.prescrKind,
        startTime: this.startTime,
        endTime: this.endTime,
        keyword: this.keyword,
      };
      this.currentPage = 1;
      orderSelfList(postData).then((data) => {
        if (data.code == 0) {
          this.tableData = data.data.data;
          let now = new Date();
          let year = now.getFullYear();
          let month = now.getMonth() + 1;
          let date = now.getDate();
          this.tableData.forEach((item) => {
            item.refundFlag = false;
            if (item.payTime) {
              let payYear = item.payTime.substring(0, 4);
              let payMonth = item.payTime.substring(5, 7);
              let payDate = item.payTime.substring(8, 10);
              if (parseInt(payYear) === year && parseInt(payMonth) === month && parseInt(payDate) === date) {
                item.refundFlag = true;
              }
            }
          });
          this.loading = false;
          this.TableTotal = data.data.count;
        } else {
          this.loading = false;
          this.outFlag = true;
          this.errorMsg = data.msg;
          setTimeout(() => {
            this.outFlag = false;
          }, 2000);
        }
      });
    },
    currentChangeHandle(page) {
      this.loading = true;
      let postData = {
        status: this.status,
        prescrKind: this.prescrKind,
        cp: page,
        lz: 10,
        keyword: this.keyword,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      orderSelfList(postData).then((data) => {
        if (data.code == 0) {
          this.tableData = data.data.data;
          let now = new Date();
          let year = now.getFullYear();
          let month = now.getMonth() + 1;
          let date = now.getDate();
          this.tableData.forEach((item) => {
            item.refundFlag = false;
            if (item.payTime) {
              let payYear = item.payTime.substring(0, 4);
              let payMonth = item.payTime.substring(5, 7);
              let payDate = item.payTime.substring(8, 10);
              if (parseInt(payYear) === year && parseInt(payMonth) === month && parseInt(payDate) === date) {
                item.refundFlag = true;
              }
            }
          });
          this.TableTotal = data.data.count;
          this.loading = false;
        } else {
          this.loading = false;
          this.outFlag = true;
          this.errorMsg = data.msg;
          setTimeout(() => {
            this.outFlag = false;
          }, 2000);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    tableRowClassName({row, column, rowIndex, columnIndex}) {
      return "statusLine";
    },
    queryPsn() {
      this.loading2 = true;
      request({
        url: `http://localhost:18665/ec/query`,
        method: 'get',
      }).then((data) => {
        this.loading2 = false
        if (data.code == 0) {
          this.dialogVisible = true;
          this.userInfo = data.data;
          if (!this.userInfo.phone) {
            this.phoneFlag = false;
          } else {
            this.phoneFlag = true;
          }
        } else {
          this.errorTipsMsg(data.msg);
        }
      })
    },
    remoteMethod(keyword) {
      if (keyword) {
        this.illNameKeyWord = keyword;
        this.illNameOptionsCp = 1;
        let postData = {
          cp: this.illNameOptionsCp,
          lz: 8,
          keyword: keyword,
        };
        dictDataList(postData).then((data) => {
          if (data.code == 0) {
            let getData = data.data.data;
            this.illNameCount = data.data.count;
            for (let a = 0; a < getData.length; a++) {
              if (!getData[a]) {
                getData[a] = {
                  diagnosisCode: a,
                  diagnosisName: a,
                };
              }
            }
            this.illNameOptions = getData;
          } else {
            this.outFlag = true;
            this.errorMsg = data.msg;
            setTimeout(() => {
              this.outFlag = false;
            }, 2000);
          }
        });
      }
    },
    loadMoreIllName() {
      this.illNameOptionsCp++;
      if (this.illNameCount > this.illNameOptions.length) {
        let postData = {
          cp: this.illNameOptionsCp,
          lz: 8,
          keyword: this.illNameKeyWord,
        };
        dictDataList(postData).then((data) => {
          if (data.code == 0) {
            let getData = data.data.data;
            for (let a = 0; a < getData.length; a++) {
              if (!getData[a]) {
                getData[a] = {
                  diagnosisCode: a,
                  diagnosisName: a,
                };
              }
              this.illNameOptions.push(getData[a]);
            }
          } else {
            this.outFlag = true;
            this.errorMsg = data.msg;
            setTimeout(() => {
              this.outFlag = false;
            }, 2000);
          }
        });
      }
    },
    bindChange(e) {
      if (e.length > 5) {
        this.$message.error("最多只能选择5个确诊诊断名称");
        this.illName.splice(-1);
      }
      this.$refs.clearValue.query = "";
    },
    clearIllNameOptions() {
      this.illNameOptions = [];
    },
    changeDisabledFlag() {
      if (this.allergyFlag == "是") {
        this.disabledFlag = false;
      } else {
        this.disabledFlag = true;
        this.fromProving.allergy_Name = false;
      }
      this.fromProving.allergy_Flag = false;
    },
    removeTag(index, item) {
      this.TagsAll.splice(index, 1);
    },
    onclick() {
      this.$nextTick(() => {
        this.$refs.inputTag.focus();
      });
    },
    addTags() {
      //新增函数中可以加一些你所需要的校验规则。比如只能是数子，或者不能输入‘，’等
      if (this.currentval && this.currentval != " ") {
        if (this.currentval.length <= 15) {
          //限制输入长度
          let flag = true;
          this.TagsAll.forEach((item) => {
            if (item == this.currentval) {
              flag = false;
            }
          });
          if (!flag) {
            this.$message({
              type: "error",
              message: "请勿重复添加相同疾病史",
            });
          } else if (this.TagsAll.length == 5) {
            this.$message({
              type: "error",
              message: "最多只能添加5个疾病史",
            });
          } else {
            //添加tag
            this.TagsAll.push(this.currentval);
            //清空输入框
          }
          this.currentval = "";
        } else {
          this.$message({
            type: "error",
            message: "单条疾病史最多15字",
          });
        }
      } else {
        this.currentval = "";
      }
    },
    deleteTags() {
      //逻辑：当删除到最后一个字符的时候，删除后currentval为空，所以继续执行，n++。这时候n=1.然后判断n是否等于2，不等于不执行。
      //这里是保证当你删除最后一个字符的时候不会执行删除tag的方法，当我们删完了字符后再按一次删除的时候，n就等于2了。就开始删除tag。
      //当有多个tag时，我们连续删除，就会出现，因为currentval为空，所以一直执行n++，导致n不等于2了，所以没法删除后面的tag。
      //所以增加判断，当n大于2的时候我们看tag的长度有没有，有那就继续删除，没有就归0，从来。
      if (this.currentval == "") {
        this.n++;
        if (this.n == 2) {
          this.TagsAll.pop();
        }
        if (this.n > 2) {
          if (this.TagsAll.length) {
            this.TagsAll.pop();
          } else {
            this.n = 0;
          }
        }
      } else {
        this.n = 0;
      }
    },
    inputStyle() {
      let style = {};
      style.width = `${this.inputLength}px`;
      return style;
    },
    allergyNameProving() {
      if (this.allergyFlag == "是") {
        if (this.allergyName == "") {
          this.fromProving.allergy_Name = true;
        } else {
          this.fromProving.allergy_Name = false;
        }
      } else {
        this.fromProving.allergy_Name = false;
      }
    },
    register() {
      this.loading = true;
      var changeLoading = setTimeout(() => {
        this.loading = false;
      }, 10000);
      let allergy_flag = 0;
      if (this.allergyFlag == "是") {
        allergy_flag = 1;
      } else {
        allergy_flag = 0;
      }
      let ill_time = 1;
      switch (this.illTime) {
        case "一个月内":
          ill_time = 1;
          break;
        case "半年内":
          ill_time = 2;
          break;
        case "一年内":
          ill_time = 3;
          break;
        case "一年以上":
          ill_time = 4;
          break;
      }
      let userId = this.userInfo.id;
      let payType = 2;

      let illName = this.illName.join(",");
      let illDesc = this.illDesc;
      var diseaseHistory = [];
      if (this.diseaseFlag == "无") {
        diseaseHistory = "无";
      } else if (this.diseaseFlag == "有") {
        diseaseHistory = this.TagsAll.join(",");
      }
      this.postdata = {
        payType: payType,
        address: this.userInfo.empName,
        allergyFlag: allergy_flag,
        allergyName: this.allergyName,
        diagnosisType: 1,
        drugs: [],
        idNo: this.userInfo.idNo,
        illDesc: illDesc,
        illName: illName,
        illTime: ill_time,
        phone: this.userInfo.phone,
        source: 3,
        type: 2,
        userName: this.userInfo.name,
        renalFunction: this.renalFunction,
        liverFunction: this.liverFunction,
        diseaseHistory: diseaseHistory,
        userId: userId,
        pharmacyId: 1,
        mdtrtCertType: "01",
        mdtrtCertNo: this.userInfo.ecToken,
      };
      this.postdata.medType = "11";
      if (this.postdata.allergyFlag === 0) {
        this.postdata.allergyName = "";
      }
      order(this.postdata).then((data) => {
        this.loading = false;
        if (data.code == 0) {
          this.$message({
            message: "挂号成功",
            type: "success",
          });
          this.$router.push("/chat");
        } else {
          this.errorTipsMsg(data.msg)
        }
        clearTimeout(changeLoading);
      });
    },
    errorTipsMsg(str) {
      this.tipsFlag = true;
      this.tipsMsg = str;
      setTimeout(() => {
        this.tipsFlag = false;
      }, 2000);
    },
  },
};
</script>
<style scoped>
.flexBox {
  display: flex;
}

.connet {
  box-sizing: border-box;
  /* padding: 24px 32px; */
  /* height: 100%; */
  /* width: 100%; */
  background: #f5f6fa;
  /* padding: 0px 32px; */
}

.orderMain {
  box-sizing: border-box;
  padding: 24px 20px;
  background: #fff;
  border-radius: 12px;
  /* width: 88%; */
  min-width: 1152px;
}

.searchButton {
  width: 116px;
  height: 44px;
  background: #0caf60;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 42px;
  text-align: center;
  cursor: pointer;
}

.searchButton:active {
  background: #86d6af;
}

.orderMain > .title {
  margin-bottom: 32px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
}

.CM_heand {
  min-width: 1264px;
}

.CM_heand > div {
  margin-right: 24px;
}

.CM_heand :last-child {
  margin-right: 0px;
}

.searchInput /deep/ input {
  min-width: 238px;
}

.topSearch {
  margin-bottom: 24px;
}

.topSearch /deep/ .el-input__inner:focus,
.topSearch /deep/ .el-range-editor.is-active {
  border-color: #0caf60;
}

.statusInput /deep/ input {
  width: 133px;
}

.status {
  padding: 4px 6px;
  font-size: 12px;
}

.Details {
  font-size: 14px;
  color: #0caf60;
  cursor: pointer;
}

.Details:active {
  color: #86d6af;
}

.button_img {
  margin-left: 20px;
  vertical-align: middle;
  cursor: pointer;
}

.paginationBox /deep/ .active {
  background: #e7f7ef;
  border-radius: 12px;
  color: #0caf60;
}

.tipsMsgBox /deep/ .el-dialog__header {
  display: none;
}

.tipsMsgBox /deep/ .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.el-table {
  margin-bottom: 14px;
}

.el-table /deep/ .statusLine .cell {
  line-height: 26px;
}

.tipsMsgBox /deep/ .el-dialog__header {
  display: none;
}

.tipsMsgBox /deep/ .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

/* Microsoft Edge 适配 */
.el-table .statusLine .cell {
  line-height: 26px;
}

.statusStyle,
.statusStyle1,
.statusStyle2,
.statusStyle3,
.statusStyle4,
.statusStyle5 {
  padding: 1px 2px;
}

.statusStyle {
  color: red;
  border: 1px solid red;
}

.statusStyle1 {
  color: darkgray;
  border: 1px solid darkgray;
}

.statusStyle2 {
  color: darkorange;
  border: 1px solid darkorange;
}

.statusStyle3 {
  color: gold;
  border: 1px solid gold;
}

.statusStyle4 {
  color: lightgreen;
  border: 1px solid lightgreen;
}

.statusStyle5 {
  color: lightgreen;
  border: 1px solid lightgreen;
}

.connet {
  padding: 1% 2%;
  min-height: 96%;
  background: rgb(245, 246, 250);
}

.connet > .tableBox {
  border-radius: 12px;
  background: #fff;
}

.connet .titleBox {
  line-height: 60px;
  font-size: 26px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
}

.connet .searchBox {
  padding: 0% 2%;
  display: flex;
  justify-content: space-between;
  background: #fff;
}

.label {
  margin-bottom: 12px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}

.label_icon {
  margin-right: 6px;
  color: #ff4d4f;
}

.label_warning {
  margin-right: 3px;
  display: inline-block;
  text-align: center;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  color: #fff;
  background: #f4333c;
}

.label_txtwarning {
  font-size: 14px;
  color: #ff4d4f;
}

.illNameSelector {
  width: 100%;
}

.illNameSelector /deep/ .el-tag--small {
  color: #0caf60;
  background-color: #fff;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #0caf60;
}

/* 外层div */
.nullValue.father_box {
  border-color: red;
}

.father_box {
  padding: 4px 0px;
  box-sizing: border-box;
  background-color: #f5f6fa;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  font-size: 12px;
  text-align: left;
  padding-left: 15px;
  word-wrap: break-word;
  overflow: hidden;
  cursor: text;
}

/* 标签 */
.spanbox {
  display: inline-block;
  font-size: 14px;
  margin: 3px 4px 3px 0;
  background-color: #ecf5ff;
  border: 1px solid #e8eaec;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

/* 标签文字 */
.tagspan {
  height: 24px;
  line-height: 22px;
  max-width: 99%;
  position: relative;
  display: inline-block;
  padding-left: 8px;
  color: #0caf60;
  font-size: 14px;
  opacity: 1;
  vertical-align: middle;
  overflow: hidden;
  transition: 0.25s linear;
}

/* tag的叉叉 */
.span_close {
  margin-left: 4px;
  padding: 0 6px 0 4px;
  opacity: 1;
  -webkit-filter: none;
  filter: none;
  color: #0caf60;
  /* font-weight: 600; */
  cursor: pointer;
}

/* 鼠标经过叉叉 */
.span_close:hover {
  background-color: #0caf60;
  border-radius: 50%;
  color: #fff;
}

.span_close:after {
  content: "\00D7";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* line-height: 27px; */
  transition: 0.3s, color 0s;
}

/* input */
.inputTag {
  font-size: 16px;
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0;
  width: auto;
  min-width: 150px;
  vertical-align: top;
  height: 32px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 32px;
}

/* 输入框提示文字大小 */
input:placeholder-shown {
  font-size: 0.6rem;
}

.dataForm td {
  padding-bottom: 12px;
}

.dataForm .dataInput {
  display: inline-block;
  width: 230px;
}

body .accountDataForm td > span {
  display: inline-block;
  width: 98px;
  text-align: right;
}

.dataForm .dataTextArea {
  width: 914px;
  vertical-align: top;
}

.dataForm .dataTextArea .el-textarea__inner {
  resize: none;
}

.el-table /deep/ .statusLine .cell {
  line-height: 26px;
}

.tipsMsgBox /deep/ .el-dialog__header {
  display: none;
}

.tipsMsgBox /deep/ .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

/* Microsoft Edge 适配 */
.el-table .statusLine .cell {
  line-height: 26px;
}

.changeButton .el-button {
  display: block;
  margin: 0 auto;
}

.tipsMsgBox .el-dialog__header {
  display: none;
}

.tipsMsgBox .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

/deep/ .is-checked .el-radio__inner {
  border-color: #0caf60;
  background: #fff;
}

/deep/ .el-radio__inner:hover {
  border-color: #0caf60;
}

/deep/ .el-radio__input.is-checked .el-radio__inner:after {
  background-color: #0caf60;
  transform: translate(-50%, -50%) scale(-1);
}

/deep/ .el-textarea textarea {
  /* border: 0px; */
  resize: none;
  background: #fafafa;
  border-radius: 8px;
}

.registerBtn {
  box-sizing: border-box;
  padding: 11px 0px;
  width: 124px;
  border-radius: 8px;
  color: #ffffff;
  background: #0caf60;
  cursor: pointer;
  border-color: #0caf60;
}

</style>